import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PrlContactUsService {

  constructor(
      private httpClient: HttpClient
  ) {
  }

  public sendMessage(data: FormData): Observable<void> {
    return this.httpClient.post<void>('/rest/contact/message/send', data);
  }
}
